module.exports = __webpack_public_path__ + "static/eingang_solemar-e9b8b54591c8fbcd4b4963167d1b973b.JPG";